import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { message, Typography } from 'antd';

import { Tab, Tabs } from '@hdi-seguros/web-components.tabs/dist/tabs';

import { CoverageCard } from '../../../../../../../shared/components/GroupedCoverageCardsList/components';
import {
  generateInputID,
  generateUniqueActivityKey,
  getCoverageAndActivityKeyByID,
} from '../../utils';

import { StepTwoFormContext } from '../../../../../StepTwo/contexts/StepTwoForm';
import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import { WizardDataFormContext } from '../../../../../../Wizard/contexts/WizardDataForm';

import { GenericDataFormContext, QuotationInfoContext, StepOneFormContext } from '../../../../../../../shared';
import {
  ColSize,
  ContentSection,
  Form,
  RowSize,
} from '../../../../../../../../../../../shared/components';

import './index.css';

export const ActivityForm = () => {
  const { activities, planWaschanged, propertyDataForm } = useContext(StepTwoFormContext);

  const {
    setLabelButton,
    quotationResponse,
    activitiesForm,
    clearPrimaFieldsOnFormChange,
    coveragesPerPlan,
    initialActivitiesForm,
    activeTab, 
    setActiveTab,
    
  } = useContext(StepThreeFormContext);

  const { getRelationWithOtherCoverage } = useContext(GenericDataFormContext);

  const { quotationForm } = useContext(WizardDataFormContext);

  const { quotationInfo } = useContext(QuotationInfoContext);

  //* Cada vez que el formulario cambie lo que voy a verificar es si es el campo del cual dependen otras coberturas.
  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton('Recotizar');
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } = getCoverageAndActivityKeyByID(nameOfFieldChanged);

      //* Verifico si la cobertura que modifique es alguna de las que dependen otras..
      const coverageCode = coveragesPerPlan.find( (el) => el.id === id )?.codigo;

      if (coverageCode) {
        //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relacion con este coverageCode.
        const relatedCoverages = coveragesPerPlan.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        //* Ahora tendria que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
        relatedCoverages.forEach(
          ({ id, porcentajeSumaAsegegurada }) => {
       
            const checkboxName = generateInputID(
              id,
              activityKey,
              'checkbox'
            );

            if (activitiesForm.getFieldValue(checkboxName)) {
              const inputName = generateInputID(
                id,
                activityKey
              );

              activitiesForm.setFieldValue(
                inputName,
                Math.round(
                  valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
                )
              );
            }
          }
        );
      }
    },
    [
      setLabelButton,
      coveragesPerPlan,
      activitiesForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
      getCoverageAndActivityKeyByID,
      generateInputID,
    ]
  );

  const ACTIVITIES_TABS: Array<Tab> = useMemo(
    () =>
      !planWaschanged
        ? activities.map(
            ({ activity, activityDescription, relationship, ageRange }, index) => ({
              key: `${activity}`,
              label: `Actividad ${activityDescription}`,
              closable: false,
              forceRender: true,
              children: (
                <React.Fragment key={`${activity}-${index}`}>
                  <ContentSection level='h3' title='Coberturas' hasCard={false}>
                    <RowSize>
                      <Typography.Title
                        level={5}
                        style={{ margin: 0, paddingLeft: 15 }}
                      >
                      </Typography.Title>
                    </RowSize>

                    <RowSize>
                      {coveragesPerPlan?.map((coverage) => {
                        const activityKey = generateUniqueActivityKey(
                          activity,
                          relationship,
                          ageRange,
                          propertyDataForm?.getFieldValue('plans'),
                        );

                        return (
                          <ColSize size={50} key={`${coverage.id}`}>
                            <CoverageCard
                              quotationInfo={quotationInfo}
                              coverage={coverage}
                              activitiesForm={activitiesForm}
                              activityKey={activityKey}
                              coveragesList={coveragesPerPlan}
                              relationWithOtherCoverage={getRelationWithOtherCoverage(
                                coverage.id,
                                coveragesPerPlan
                              )}
                              sumaAseguradaInputName={generateInputID(
                                coverage.id,
                                activityKey
                              )}
                              primaInputName={generateInputID(
                                coverage.id,
                                activityKey,
                                'prima'
                              )}
                              checkboxName={generateInputID(
                                coverage.id,
                                activityKey,
                                'checkbox'
                              )}
                            />
                          </ColSize>
                        );
                      })}
                    </RowSize>
                  </ContentSection>
                  
                </React.Fragment>
              ),
            })
          )
        : [],
    [
      activities,
      coveragesPerPlan,
      activitiesForm,
      getRelationWithOtherCoverage,
      quotationForm,
      planWaschanged,
    ]
  );

  const showErrorMessageOnActivity = async (activity: string) => {
    const fields = activitiesForm.getFieldsError();

    const fieldsOfActivity = fields.filter((el) => {
      const { activityKey } = getCoverageAndActivityKeyByID(el.name[0].toString());
      const activityCode = activityKey.split('-')[0];
      return activityCode === activity;
    });

    if (fieldsOfActivity.find((el) => el.errors.length)) {
      message.error(
        `Posee errores en el formulario de la actividad ${activeTab}`
      );
    }
  };

  const handlePressTab = (activeKey: string) => {
    setActiveTab(activeKey);
    showErrorMessageOnActivity(activeTab);
  };

  return (
    <Form
      formProps={{
        form: activitiesForm,
        name: 'activities-form',
        onFieldsChange: onChangeForm,
        initialValues: initialActivitiesForm
      }}
    >
      <Tabs
        handlePressTab={handlePressTab}
        activeKey={activeTab}
        items={ACTIVITIES_TABS}
      />
    </Form>
  );
};
